import {Component, OnInit} from '@angular/core';
import {HeizkostenabrechnungStepComponent} from "./heizkostenabrechnung.step.component";
import {DecimalPipe} from "@angular/common";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {HeizcheckRequestService} from "../services/heizcheck-request.service";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {TranslateService} from "@ngx-translate/core";
import {EnergyMapService} from '../../energy-map/services/energy.map.service';
import {HeizkostenabrechnungForm} from "./heizkostenabrechnung.form";

/**
 * Custom Step for the input of costs
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-heizkostenabrechnung-kosten',
    templateUrl: './heizkostenabrechnung.grouped.step.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class HeizkostenabrechnungKostenStepComponent extends HeizkostenabrechnungStepComponent implements OnInit{

  /**
   * @inheritDoc
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   * @param decimalPipe
   * @param translate
   * @param energyMapService
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: HeizcheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService, protected decimalPipe: DecimalPipe, protected translate: TranslateService, protected energyMapService: EnergyMapService) {
    super(stepService, router, requestService, elementService, portalService, translate, energyMapService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // do not show step help
    this.hasHelp = false;

    // init subheadlines for the current step
    this.initSubheadlines();

    // if there are changes in the form, reset the warnings
    this.subscriptions.push(this.form.valueChanges.subscribe(() => {
      this.formWarning = null;

      // todo, restart the calculation and let the user know if it is corrected
    }));
  }

  /**
   * @inheritDoc
   */
  moveToNextStep(): void {
    if (this.steps.currentStep.name === 'kostendetails') {
      this.calculateCostdetails();
    }
  }

  /**
   * send input to the backend and receive result from the heating bill api
   */
  calculateCostdetails(): void {
    this.loading = true;
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      const input = this.anfrage.heizkostenanalyseInput;

      this.requestService.backendService.heizkostenanalyse(input, requestId).subscribe(result => {
        if(typeof result.result === "undefined") {
          this.formError = 'connection';
          throw new Error('Invalid result from server. No result found for requestId ' + requestId);
        }

        this.loading = false;
        this.invoiceErrors = null;
        this.backendErrors = null;
        this.anfrage.heizkostenanalyseResult = result;
        this.requestService.setAnfrage(this.anfrage);

        // check if there is a warning and if we want to show this, ignore non-pupblic warnings and possibly_cold_water_costs_included warning
        const warnings = result.result.status.warnings.filter(
          warning => warning.type === 'public' &&
            [HeizkostenabrechnungForm.WARNING_ENERGYPRICE, HeizkostenabrechnungForm.WARNING_COLDWATER].indexOf(warning.code) === -1
        );
        if(!this.formWarning && warnings.length > 0 && warnings[0].code) {

          // overall costs of the apartement
          let wohnung_heizkosten_gesamt = this.anfrage.heizkostenanalyseInput.wohnung_heizkosten_raumwaerme ?? 0;
          wohnung_heizkosten_gesamt += this.anfrage.heizkostenanalyseInput.wohnung_heizkosten_warmwasser ?? 0;

          this.formWarning = warnings[0].code;
          this.warningPlaceholder = {
            wohnung_heizkosten_gesamt_abweichung_absolut: this.decimalPipe.transform(Math.abs(result.result.data.abrechnung.wohnung_heizkosten_gesamt_abweichung_absolut), '1.2-2'),
            wohnung_heizkosten_gesamt_abweichung_prozent: this.decimalPipe.transform(Math.abs(result.result.data.abrechnung.wohnung_heizkosten_gesamt_abweichung_prozent), '1.0-0'),
            wohnung_heizkosten_gesamt: this.decimalPipe.transform(wohnung_heizkosten_gesamt, '1.2-2')
          };
          return;
        }

        super.moveToNextStep();
        return;

      },error => {
        this.loading = false;
        if(error?.status === 400) {
          this.invoiceErrors = {error: 'input', fields: error.error?.result?.status?.errors[0]?.affected_fields || []};
          // show specific error message, based on backend reply
          this.backendErrors = error.error?.result?.status ? error.error.result.status.errors.map(error => {
            return this.textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.error.' + error.code + '|heizkostenabrechnung';
          }) : [];
        }
        else {
          // generic error, mostly on the connection to the backend.
          this.formError = 'connection';
        }
        this.elementService.scrollToElement(this.stepForm.nativeElement);
      });
    });
  }

}

